"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileGroupComponent = exports.TileGroupComponent = void 0;
const app_1 = require("app");
const Tile_1 = require("../Tile");
const dictionary_1 = require("./dictionary");
const TileGroup_1 = require("./components/containers/TileGroup");
const index_1 = require("./types/index");
class TileGroupComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.tile-group-component';
        this.getElementData = (el, totalCount) => {
            const hasFewTiles = totalCount > 0 && totalCount <= 2;
            const isTileGroupCard = el.querySelectorAll('.tile-group-card').length > 0;
            const groupType = app_1.AttrService.data(el, 'group-type');
            const tileShapeValue = app_1.AttrService.data(el, 'tile-shape');
            const tileShape = tileShapeValue !== null && tileShapeValue !== void 0 ? tileShapeValue : (isTileGroupCard
                ? hasFewTiles
                    ? Tile_1.TileShapeEnum.CardBig
                    : Tile_1.TileShapeEnum.Card
                : Tile_1.TileShapeEnum.Wide);
            return {
                apiUrl: app_1.AttrService.data(el, 'api-url'),
                culture: app_1.AttrService.data(el, 'culture'),
                currentPageId: app_1.AttrService.data(el, 'current-page-id'),
                offset: app_1.AttrService.data(el, 'offset'),
                pageSize: app_1.AttrService.data(el, 'page-size'),
                defaultImageType: app_1.AttrService.data(el, 'default-image-type'),
                isDescriptionExpandable: app_1.AttrService.data(el, 'description-expandable'),
                tags: app_1.AttrService.data(el, 'tags'),
                tileShape,
                tileType: groupType === index_1.groupTypes.recommendedCourses
                    ? Tile_1.TileTypeEnum.SabaCourses
                    : Tile_1.TileTypeEnum.TileGroupContent,
                groupType,
                totalCount,
                types: app_1.AttrService.data(el, 'types'),
                items: app_1.AttrService.data(el, 'items'),
                loadMoreBtnLabel: app_1.AttrService.data(el, 'more'),
                loadLessBtnLabel: app_1.AttrService.data(el, 'less'),
                checkAllBtnLabel: app_1.AttrService.data(el, 'check-all-label'),
                redirectUrl: app_1.AttrService.data(el, 'redirect-url'),
                dictionary: (0, app_1.transformDictionary)(dictionary_1.tileGroupDictionary, app_1.AttrService.data(el, 'dictionary')),
            };
        };
    }
    OnInit() {
        this.el.forEach(el => {
            const totalCount = parseInt(app_1.AttrService.data(el, 'total-count'), 10);
            const data = this.getElementData(el, totalCount);
            const transformedData = (0, app_1.keysToCamel)(data);
            (0, TileGroup_1.RenderTileGroup)(transformedData, el);
        });
        app_1.ComponentService.UpdateComponentsSelector();
    }
}
exports.TileGroupComponent = TileGroupComponent;
exports.tileGroupComponent = new TileGroupComponent();
